var _path, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandmore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 55,
    viewBox: "0 0 27 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 12.6863 2.68629 10 6 10H24V46H6C2.68629 46 0 43.3137 0 40V16Z",
    fill: "#0B2653"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 3,
    height: 55,
    fill: "#0B2653"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9638_86970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74155 24.7669L12.9749 28.0003L9.74155 31.2336C9.41655 31.5586 9.41655 32.0836 9.74155 32.4086C10.0666 32.7336 10.5916 32.7336 10.9166 32.4086L14.7416 28.5836C15.0666 28.2586 15.0666 27.7336 14.7416 27.4086L10.9166 23.5836C10.5916 23.2586 10.0666 23.2586 9.74155 23.5836C9.42489 23.9086 9.41655 24.4419 9.74155 24.7669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9638_86970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 38) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandmore);
export default __webpack_public_path__ + "static/media/expandmore.46c792e0ef715f31f8a707e76d7fbd87.svg";
export { ForwardRef as ReactComponent };